import { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper';
SwiperCore.use([Navigation]);
import sliderimg from '../../../styles/images/cnbc-default-image.webp';

import GetData from '../../../services/GetData';
import { requests, baseUrlAdmin } from '../../../services/Requests';
import Link from 'next/link';
import VideoDuration from '../../HelperComponents/VideoDuration';
import { handleElkAndDbResponse } from '../../../services/ResponseMapping';
import CategoriesLinks from '../CategoriesLinks/CategoriesLinks';
import TimeAgoArabicFormat from '../TimeAgoCustom/TimeAgoArabicFormat';
import Thumbnail from '../../Thumbnail';
import Title from '../../Title';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


const NewsFooter2SliderWithColoredBackGround=({ title }) => {
  const [exclusiveVideosNewsList, setExclusiveVideosNewsList] = useState<any>([]);

  useEffect(() => {
    GetData(
      `${requests.exclusiveVideosNews}&limit=10&pageNo=1`,
      {},
      'get',
      false
    )
      .then((res) => {
        let newsResult = res.data && res.data.length ? res.data : [];
        newsResult = handleElkAndDbResponse(newsResult);
        setExclusiveVideosNewsList(newsResult);
      })
      .catch((err) => {
        console.warn(err);
      });
  }, []);

  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  return (
    <>
      <div className="newsSliderText newsSlider2Text">
        <div className="row">
          <div className="col-sm-7">
            <div className="float-end">

              <Title styles={'TitleBar'}>
                <h2>{title}</h2>
              </Title>
            </div>
          </div>
          <div className="col-sm-5">
            <div className="sliderArrows text-start pt-0">
              <button
                className="slider-arrow arrow-prev"
                ref={navigationPrevRef}
              >
                Previous
              </button>
              <button
                className="slider-arrow arrow-next"
                ref={navigationNextRef}
              >
                Next
              </button>
            </div>
          </div>
        </div>
        <Swiper
          navigation={{
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
          dir="rtl"
          slidesPerView={2.5}
          spaceBetween={20}
          slidesPerGroup={1}
          breakpoints={{
            '1024': { slidesPerView: 2.5 },
            '992': { slidesPerView: 1.5 },
            '575': { slidesPerView: 1.5 },
            '375': { slidesPerView: 1.5 },
            '320': { slidesPerView: 1.5 },
          }}
          pagination={false}
          modules={[Navigation, Pagination]}
          className="mySwiper"
        >
          {exclusiveVideosNewsList.map((news: any, index: number) => {
            return (
              <SwiperSlide key={index}>
                <div className="slider-item">
                  <div className="NewsBox ">
                    <Link
                      href={`/${news?.routePath}`}
                    >
                      <div className="newsImage">
                        {news?.thumbnail?.url ? (
                          <Thumbnail
                            showThumbnail={true}
                            className="img-fluid"
                            src={news?.thumbnail?.url}
                          />
                        ) : news?.thumbnail?.path ? (
                          <Thumbnail
                            showThumbnail={true}
                            className="img-fluid"
                            src={baseUrlAdmin + news?.thumbnail?.path}
                          />
                        ) : (
                          <Thumbnail
                            showThumbnail={true}
                            className="img-fluid"
                            src={sliderimg.src}
                          />
                        )}
                        <div className="PlayTime">
                          <VideoDuration data={news?.video} />

                          <div
                            className="PlayButton-featured_50 PlayButton-base "
                            data-type="play"
                          >
                            <span className="PlayButton-flyout">شاهد الآن</span>
                            <span className="icon-play-triangle PlayButton-icon">
                              <i className="fa play_medium"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </Link>
                    <div className="newscontent">
                      <h5>
                        <Link
                          href={`/${news?.routePath}`}
                        >
                          <a href="#" aria-label="Go to 97">{news?.title}</a>
                        </Link>
                      </h5>
                      <p>
                        <CategoriesLinks
                          categories={news && news?.categories}
                        />
                        <b>
                          <TimeAgoArabicFormat date={news?.createdAt} />
                        </b>
                      </p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </>
  );
};

export default NewsFooter2SliderWithColoredBackGround;
